module.exports = __webpack_public_path__ + "img/grancanaria.b5dfb3f2.jpg";